<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="panel panel-default">
        <div class="panel-body">
          <table class="table table-condensed table-striped">
            <thead>
            <tr>
              <th class="col-xs-1"></th>

              <th class="col-xs-11">
                Name
              </th>

              <th class="col-xs-11">
                Type
              </th>

              <th class="col-xs-1"></th>
            </tr>
            </thead>

            <draggable
                element="tbody"
                :value="channels"
                :options="{handle: '.handle', chosenClass: 'interval--dragging'}"
                @input="sorted"
            >
              <tr v-for="channel in channels">
                <td class="text-center">
                  <i class="fa fa-arrows-alt handle"></i>
                </td>

                <td>
                  <router-link :to="getLink(channel)">
                    {{ channel.name }}
                  </router-link>
                </td>

                <td>
                  <span
                      v-if="channel.type === 'time-based-channels'"
                      class="label label-info"
                  >
                    Time
                  </span>

                  <span
                      v-if="channel.type === 'publication-based-channels'"
                      class="label label-success"
                  >
                    Publication
                  </span>
                </td>

                <td class="text-right">
                  <div class="btn-group list-actions">
                    <router-link
                        :to="getLink(channel)"
                        class="btn btn-sm"
                    >
                      <i class="fa fa-search"></i>
                    </router-link>
                  </div>
                </td>
              </tr>

              <tr v-if="!channels.length">
                <td colspan="4" class="text-center">
                  <i>
                    There are no channels to display.
                  </i>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Draggable from 'vuedraggable'
import LoadingContainer from '@/components/Layout/LoadingContainer'

export default {
  components: {Draggable, LoadingContainer},

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal'],

  data() {
    return {
      channels: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v1/channels', {'filter[portal_id]': this.portal.id}).then(response => {
        this.channels = response.data.data

        this.loading = false
      })
    },

    getLink(channel) {
      return '/portals/' + this.portal.id + '/' + channel.type + '/' + channel.id
    },

    sorted(channels) {
      this.channels = channels

      http.put('/api/v1/channels/priorities', {channels: channels})
          .then(() => {
            notify.success('The channels were sorted')
          })
    }
  }
}
</script>
